export default "__VITE_ASSET__DexZZynl__"